import React, { useRef, useEffect } from 'react';
import cx from 'classnames';
import { useLocation } from 'react-router-dom';
import '../../../form/CheckBox/index.js';
import '../../../form/CodeInput/index.js';
import '../../../form/CryptoSelect/index.js';
import '../../../form/FileUploader/index.js';
import '../../../form/FormInput/index.js';
import '../../../form/FormSelect/index.js';
import '../../../form/PhoneInput/index.js';
import '../../../form/RadioButton/index.js';
import '../../../form/Select/index.js';
import '../../../form/SelectV2/index.js';
import '../../../form/SelectV3/index.js';
import '../../../form/SelectV4/index.js';
import { SearchInput } from '../../../form/Search/Input/index.js';
import '../../../form/Search/NoResults/index.js';
import '../../../form/Switch/index.js';
import '../../../form/DatePickerInput/index.js';
import '../../../ui/accordions/Accordion/index.js';
import '../../../ui/accordions/AccordionSelect/index.js';
import '../../../ui/badges/Badge/index.js';
import '../../../ui/badges/BadgeIcon/index.js';
import '../../../ui/badges/Checked/index.js';
import '../../../ui/badges/Panel/index.js';
import '../../../ui/badges/Status/index.js';
import '../../../ui/badges/Tag/index.js';
import '../../../ui/buttons/BabyButton/Base.js';
import '../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import '../../../ui/buttons/Button/index.js';
import '../../../ui/buttons/CloseButton/index.js';
import '../../../ui/buttons/DirectionButton/index.js';
import '../../../ui/buttons/GradientButton/index.js';
import '../../../ui/buttons/GradientButtonV2/index.js';
import '../../../ui/buttons/TabButton/index.js';
import '../../../ui/buttons/TabButtonV2/index.js';
import '../../../ui/buttons/TimerButton/index.js';
import '../../../ui/buttons/TimerButtonV2/index.js';
import '../../../ui/buttons/TimerButtonV3/index.js';
import { Loader } from '../../../ui/loaders/Loader/index.js';
import '../../../ui/loaders/ScreenLoader/index.js';
import { ModalComponent } from '../../../ui/modals/Modal/index.js';
import '../../../ui/popups/Popper/index.js';
import '../../../ui/popups/Popup/BasePopup/index.js';
import '../../../ui/popups/Popup/Thumb/index.js';
import '../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../ui/sliders/EmblaCarousel/index.js';
import '../../../ui/tables/Table/index.js';
import '../../../ui/tables/Table/TableTd/index.js';
import '../../../ui/tabs/Tabs/index.js';
import '../../../ui/tabs/TabsV2/index.js';
import '../../../ui/texts/CryptoValue/index.js';
import '../../../ui/texts/AmountValue/index.js';
import '../../../ui/texts/TitleWithCurrency/index.js';
import '../../../ui/texts/Text/index.js';
import '../../../ui/texts/TextNavigation/index.js';
import '../../../ui/texts/MinValue/index.js';
import '../../../ui/socials/SocialsList/index.js';
import '../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import '../../../common/GradientWrapper/index.js';
import '../../../common/Icon/index.js';
import '../../../common/LazyImage/index.js';
import '../../../common/NumberFormat/index.js';
import { WithCustomScrollbar } from '../../../common/WithCustomScrollbar/index.js';
import '../../../cards/AuthPromo/index.js';
import { Card } from '../../../cards/Card/index.js';
import '../../../cards/CategoryCard/index.js';
import '../../../cards/CryptoFeature/index.js';
import '../../../cards/GamePreview/index.js';
import '../../../cards/Promo/PromoCardSimple/index.js';
import '../../../cards/Promo/PromotionCard/index.js';
import '../../../cards/Provider/index.js';
import '../../../cards/SportsBook/index.js';
import '../../../cards/SecurityCard/index.js';
import '../../../cards/WinCard/index.js';
import '../../lists/GameList/GameListHeader/index.js';
import '../../lists/GameList/index.js';
import '../../lists/GamesListTopBar/index.js';
import '../../lists/LiveLoad/index.js';
import '../../lists/LiveWins/index.js';
import { NavigationBar } from '../../lists/NavigationBar/index.js';
import '../../lists/PageNavigationBar/index.js';
import '../../lists/NavigationBarV2/index.js';
import '../../lists/PageNavigationBarV2/index.js';
import { Pagination } from '../../lists/Pagination/index.js';
import '../../lists/PaginationLocal/index.js';
import '../../lists/ProvidersList/ProvidersListHeader/index.js';
import '../../lists/ProvidersList/index.js';
import '../../lists/SocialLinks/index.js';
import { useWindowSize } from '../../../../utils/hooks/useWindowSize.js';
import { DEFAULT_BOTTOM_MODAL_STYLE_CONFIG } from '../../../ui/modals/Modal/config/index.js';
import styles from './index.module.scss.js';

const SearchModal = ({
  navigationList,
  list,
  searchStr,
  setSearchStr,
  isOpen,
  onClose,
  onLinkChange,
  isLoading,
  pagination,
  showNavigationBar,
  afterOpenModal = () => {
  },
  onAfterClose = () => {
  },
  text = {
    inputPlaceholder: "Search by game, providers etc.",
    emptyListMsg: "No result"
  },
  animations = {
    search: {
      "data-aos": "fade-up",
      "data-aos-delay": "100",
      "data-aos-duration": "1000"
    },
    navigation: {
      "data-aos": "fade-up",
      "data-aos-delay": "200",
      "data-aos-duration": "1000"
    },
    list: {
      "data-aos": "fade-up",
      "data-aos-delay": "300",
      "data-aos-duration": "1000"
    },
    pagination: {
      "data-aos": "fade-up",
      "data-aos-delay": "400",
      "data-aos-duration": "1000"
    }
  }
}) => {
  const { isMobile } = useWindowSize();
  const location = useLocation();
  const inputSearchRef = useRef(null);
  useEffect(() => {
    onClose();
  }, [location]);
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        if (inputSearchRef) {
          inputSearchRef?.current?.focus();
        }
      });
    }
  }, [isOpen]);
  return /* @__PURE__ */ React.createElement(
    ModalComponent.Modal,
    {
      modalIsOpen: isOpen,
      closeModal: () => onClose(),
      hideCloseButton: true,
      withWrapper: isMobile,
      bottom: true,
      portalClassName: styles.box,
      mobileWrapperV2: true,
      afterOpenModal,
      onAfterClose,
      configuration: isMobile ? {
        ...DEFAULT_BOTTOM_MODAL_STYLE_CONFIG(),
        overlay: {
          ...DEFAULT_BOTTOM_MODAL_STYLE_CONFIG().overlay,
          height: "100vh"
        },
        content: {
          ...DEFAULT_BOTTOM_MODAL_STYLE_CONFIG().content,
          height: "calc(100vh - 10px)"
        },
        childrenWrapper: {
          borderRadius: 0
        }
      } : {
        content: {
          height: isMobile ? "100%" : "600px",
          maxHeight: isMobile ? "100%" : "90%",
          width: "1096px",
          maxWidth: isMobile ? "100%" : "80%",
          overflow: isMobile ? "auto" : "visible",
          backgroundColor: "transparent",
          boxShadow: "unset",
          padding: 0,
          borderRadius: 12
        },
        childrenWrapper: {
          overflow: "visible",
          background: "#051215",
          border: "1px solid rgba(8, 51, 60, 1)"
        }
      }
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.header, ...animations?.search }, /* @__PURE__ */ React.createElement(
      SearchInput,
      {
        value: searchStr,
        onChange: (event) => {
          if (event.target) {
            setSearchStr(event.target.value);
          } else {
            setSearchStr(event);
          }
        },
        isFocusStyle: true,
        onSubmit: () => {
        },
        inputTheme: "blue",
        placeholder: text.inputPlaceholder,
        id: "search-modal-input",
        ref: inputSearchRef,
        clearButton: true
      }
    ), showNavigationBar && /* @__PURE__ */ React.createElement(
      NavigationBar,
      {
        className: styles.navigation,
        list: navigationList,
        v2: true,
        navBarFullWidth: true,
        search: false,
        listAnimation: animations?.navigation,
        searchAnimation: animations?.navigation,
        onLinkChange
      }
    )),
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles.body, {
          [styles["with-navbar"]]: showNavigationBar
        })
      },
      /* @__PURE__ */ React.createElement(WithCustomScrollbar, { className: styles.scroll }, !!list.length && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        "div",
        {
          className: cx(styles.list, "search-modal__list"),
          ...animations?.list
        },
        list.map((item) => /* @__PURE__ */ React.createElement(
          Card,
          {
            ...item,
            index: item.id,
            key: item.id,
            additionalInfo: void 0
          }
        ))
      ), pagination && /* @__PURE__ */ React.createElement(
        Pagination,
        {
          onLoadMore: () => {
            pagination.onLoadMore();
          },
          meta: pagination.listMeta
        }
      )), !list.length && !isLoading && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: styles.empty, ...animations?.list }, text.emptyListMsg), pagination && /* @__PURE__ */ React.createElement(
        Pagination,
        {
          onLoadMore: () => {
            pagination.onLoadMore();
          },
          meta: pagination.listMeta
        }
      )), isLoading && /* @__PURE__ */ React.createElement(Loader, null))
    )
  );
};

export { SearchModal };
//# sourceMappingURL=index.js.map
